import React, { MouseEventHandler } from 'react';

import { CARD_CONFIG } from '../../pages/home/constants/card-config';
import { Label } from '../label/label';
import PresentationalLink from '../presentational-link/presentational-link';
import { Text } from '../text/text';
import { Translate } from '../translate';
import './nav-card.scss';

type NavCardProps = {
  cardId: string;
  navText: string;
  navDirection: 'forward' | 'backward';
  onNav: MouseEventHandler<HTMLDivElement>;
};
const NavCard: React.FC<NavCardProps> = ({ cardId, navText, navDirection, onNav }) => {
  const { label, labelColor, title, icon: IconComponent } = CARD_CONFIG[cardId];

  return (
    <div className="bd-nav-card" onClick={onNav}>
      {IconComponent && <IconComponent className="bd-nav-card__icon" />}
      <div className="bd-nav-card__text">
        <div className="bd-nav-card__text">
          <Label color={labelColor} size="x-small">
            <Translate id={label} />
          </Label>
          <Text weight="bold">
            <Translate id={title} />
          </Text>
        </div>
        <PresentationalLink onClick={onNav} direction={navDirection}>
          <Translate id={navText} />
        </PresentationalLink>
      </div>
    </div>
  );
};

export default NavCard;
